import React, { Component } from 'react';
import SakuraOrbit from './SakuraOrbit';
import PageMeta from './PageMeta';
import { Link } from 'react-router-dom';
import { DataRPC } from '../../rpc-client/DataRPC';
import { s3 } from '../../config/constants';
import SakuraSep from './SakuraSep';

const rpc = new DataRPC();

function formatDate(str) {
    if (!str) return '';
    const d = new Date(str);
    return `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}`;
}

function FeaturedCard({ item, large }) {
    return (
        <Link to={`/news/${item.slug || item.id}`} className={`ncat-featured${large ? ' ncat-featured--large' : ''}`}>
            <div className="ncat-featured-img-wrap">
                <img src={s3(item.avatar_url, 'images/news-image-1.jpg')} alt={item.title} className="ncat-featured-img" />
                {item.is_hot_news === 1 && <span className="nws-hot-badge">HOT</span>}
            </div>
            <div className="ncat-featured-body">
                <span className="ncat-date">{formatDate(item.published_at || item.created_at)}</span>
                <h2 className="ncat-featured-title">{item.title}</h2>
                {large && <p className="ncat-featured-excerpt">{item.short_description}</p>}
            </div>
        </Link>
    );
}

function SubCard({ item }) {
    return (
        <Link to={`/news/${item.slug || item.id}`} className="ncat-sub-card">
            <div className="ncat-sub-img-wrap">
                <img src={s3(item.avatar_url, 'images/news-image-1.jpg')} alt={item.title} className="ncat-sub-img" />
            </div>
            <div className="ncat-sub-body">
                <span className="ncat-date">{formatDate(item.published_at || item.created_at)}</span>
                <h3 className="ncat-sub-title">{item.title}</h3>
            </div>
        </Link>
    );
}

function ListItem({ item, index }) {
    return (
        <Link to={`/news/${item.slug || item.id}`} className="ncat-list-item">
            <span className="ncat-list-idx">{String(index + 1).padStart(2, '0')}</span>
            <img src={s3(item.avatar_url, 'images/news-image-1.jpg')} alt={item.title} className="ncat-list-thumb" />
            <div className="ncat-list-body">
                <span className="ncat-date">{formatDate(item.published_at || item.created_at)}</span>
                <h3 className="ncat-list-title">{item.title}</h3>
            </div>
        </Link>
    );
}

const MOCK_DOMESTIC = [
    { id: 'm1', avatar_url: 'images/next-event-1.jpg', title: 'VYF 2026 chính thức khởi động – Hàng nghìn vũ công sẵn sàng tranh tài', short_description: 'Lễ hội Yosakoi Việt Nam 2026 đã chính thức bắt đầu vòng loại với sự tham gia của hơn 80 đội từ khắp cả nước.', published_at: '2026-03-15', type: 1, is_hot_news: 1 },
    { id: 'm2', avatar_url: 'images/next-event-2.jpg', title: 'Hà Nội mở rộng khu vực biểu diễn Yosakoi tại phố đi bộ Hoàn Kiếm', short_description: 'Ban tổ chức thông báo mở rộng sân khấu chính tại phố đi bộ Hoàn Kiếm nhằm đáp ứng lượng khán giả kỷ lục.', published_at: '2026-02-28', type: 2, is_hot_news: 0 },
    { id: 'm3', avatar_url: 'images/next-event-3.jpg', title: 'Đội VYF Sài Gòn Fire giành giải Nhất vòng loại miền Nam', short_description: 'Màn trình diễn ấn tượng với trang phục truyền thống kết hợp hiện đại đã giúp đội giành chiến thắng thuyết phục.', published_at: '2026-02-10', type: 1, is_hot_news: 0 },
];

const MOCK_INTERNATIONAL = [
    { id: 'm4', avatar_url: 'images/blog-image-1.jpg', title: 'Nhật Bản gửi đoàn 12 đội Yosakoi tham dự VYF 2026', short_description: 'Đây là lần đầu tiên phái đoàn Nhật Bản cử số lượng đội tham dự kỷ lục, khẳng định tầm vóc quốc tế của lễ hội.', published_at: '2026-03-01', type: 4, is_hot_news: 1 },
    { id: 'm5', avatar_url: 'images/blog-image-2.jpg', title: 'Lễ hội Yosakoi Kochi 2026 lập kỷ lục người tham dự', published_at: '2026-01-20', type: 4, is_hot_news: 0 },
    { id: 'm6', avatar_url: 'images/blog-image-3.jpg', title: 'UNESCO ghi nhận Yosakoi là di sản văn hóa phi vật thể của Nhật Bản', published_at: '2025-12-05', type: 3, is_hot_news: 0 },
    { id: 'm7', avatar_url: 'images/news-image-1.jpg', title: 'Hàn Quốc và Đài Loan lần đầu thành lập đội Yosakoi tham dự quốc tế', published_at: '2025-11-18', type: 4, is_hot_news: 0 },
    { id: 'm8', avatar_url: 'images/news-image-2.jpg', title: 'Ban tổ chức VYF ký kết hợp tác với Hiệp hội Yosakoi Nhật Bản', published_at: '2025-10-30', type: 3, is_hot_news: 0 },
];

class News extends Component {
    state = { domestic: [], international: [], loading: true, searchQuery: '' };

    componentDidMount() {
        rpc.fetchRawData('GetNews', { page: 1, limit: 50, status: 'published' })
            .then(res => {
                const all = res.data || [];
                let domestic      = all.filter(n => [1, 2].includes(n.type));
                let international = all.filter(n => ![1, 2].includes(n.type));
                if (domestic.length === 0)      domestic      = MOCK_DOMESTIC;
                if (international.length === 0) international = MOCK_INTERNATIONAL;
                this.setState({ domestic, international, loading: false });
            })
            .catch(() => this.setState({ domestic: MOCK_DOMESTIC, international: MOCK_INTERNATIONAL, loading: false }));
    }

    renderColumn(items, title, side) {
        if (!items.length) return null;
        const [featured, ...rest] = items;

        return (
            <div className={`ncat-col${side ? ' ncat-col--side' : ''}`}>
                <div className="ncat-col-header">
                    <span className="ncat-col-label">{title}</span>
                </div>

                <FeaturedCard item={featured} large={!side} />

                {!side && rest.length > 0 && (
                    <div className="ncat-sub-grid">
                        {rest.slice(0, 2).map(item => <SubCard key={item.id} item={item} />)}
                    </div>
                )}

                {side && rest.length > 0 && (
                    <div className="ncat-list">
                        {rest.slice(0, 4).map((item, i) => <ListItem key={item.id} item={item} index={i} />)}
                    </div>
                )}
            </div>
        );
    }

    filter(items, q) {
        if (!q) return items;
        const lq = q.toLowerCase();
        return items.filter(n =>
            (n.title || '').toLowerCase().includes(lq) ||
            (n.short_description || '').toLowerCase().includes(lq)
        );
    }

    render() {
        const { domestic, international, loading, searchQuery } = this.state;
        const q = searchQuery.trim();
        const filteredDom  = this.filter(domestic, q);
        const filteredIntl = this.filter(international, q);
        const noResults    = q && filteredDom.length === 0 && filteredIntl.length === 0;

        return (
            <>
                <PageMeta title="Tin tức" description="Cập nhật tin tức mới nhất về Vietnam Yosakoi Festival." url="/news" image="https://vietnamyosakoi.com/images/blog-header-background.jpg" />
                <div className="page-header news-page-header">
                    <div className="page-header-overlay" />
                    <div className="container page-header-body">
                        <div className="row">
                            <div className="col-12">
                                <div className="entry-meta-date">Việt Nam Yosakoi Festival</div>
                                <h1 className="page-header-title">TIN TỨC</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="sep-gold-rule" style={{margin: 0}} />

                <div className="nws-page">
                    <div className="container">
                        <div className="ncat-top-bar">
                            <div className="entry-title" style={{margin: 0}}>
                                <p>CẬP NHẬT MỚI NHẤT</p>
                                <h2>TIN TỨC & SỰ KIỆN</h2>
                            </div>
                            <div className="ncat-search-wrap">
                                <svg className="ncat-search-icon" viewBox="0 0 20 20" fill="none">
                                    <circle cx="8.5" cy="8.5" r="5.5" stroke="currentColor" strokeWidth="1.6"/>
                                    <path d="M13 13l3.5 3.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
                                </svg>
                                <input
                                    className="ncat-search-input"
                                    type="text"
                                    placeholder="Tìm kiếm tin tức..."
                                    value={searchQuery}
                                    onChange={e => this.setState({ searchQuery: e.target.value })}
                                />
                                {searchQuery && (
                                    <button className="ncat-search-clear" onClick={() => this.setState({ searchQuery: '' })}>✕</button>
                                )}
                            </div>
                        </div>

                        {loading ? (
                            <SakuraOrbit label="Đang tải tin tức" />
                        ) : noResults ? (
                            <div className="nws-empty">Không tìm thấy tin tức nào cho "<strong>{q}</strong>".</div>
                        ) : (domestic.length === 0 && international.length === 0) ? (
                            <div className="nws-empty">Chưa có tin tức nào.</div>
                        ) : (
                            <div className="ncat-grid">
                                {this.renderColumn(filteredDom,  'Tin Tức Trong Nước', false)}
                                {filteredDom.length > 0 && filteredIntl.length > 0 && <div className="ncat-divider" />}
                                {this.renderColumn(filteredIntl, 'Tin Tức Quốc Tế',    true)}
                            </div>
                        )}
                    </div>

                    <SakuraSep />
                </div>

                <div className="sep-gold-rule" style={{margin: 0}} />
            </>
        );
    }
}

export default News;
